// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddCust_importCsvCard__8wtBn","addCustomerBtnContainer":"AddCust_addCustomerBtnContainer__hUHYE"};